// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "oldVersion-kV8Nl";
var _3 = "change-3u9e_";
export { _1 as "__esModule", _2 as "oldVersion", _3 as "change" }
export default { "__esModule": _1, "oldVersion": _2, "change": _3 }
